
const m = window.require("@ember/routing/route");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
